import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1298.82353,1581.17647 C1298.82353,1767.98118 1146.80471,1920 960,1920 C773.195294,1920 621.176471,1767.98118 621.176471,1581.17647 L1298.82353,1581.17647 Z M1016.47059,0 L1016.47059,115.764706 C1394.93647,144.790588 1694.11765,461.364706 1694.11765,847.058824 L1694.11765,847.058824 L1694.11765,1129.41176 C1694.11765,1253.98588 1795.42588,1355.29412 1920,1355.29412 L1920,1355.29412 L1920,1468.23529 L0,1468.23529 L0,1355.29412 C124.574118,1355.29412 225.882353,1253.98588 225.882353,1129.41176 L225.882353,1129.41176 L225.882353,847.058824 C225.882353,461.364706 525.063529,144.790588 903.529412,115.764706 L903.529412,115.764706 L903.529412,0 L1016.47059,0 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconAlertsSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconAlertsSolid, _Component);

  var _super = _createSuper(IconAlertsSolid);

  function IconAlertsSolid() {
    _classCallCheck(this, IconAlertsSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconAlertsSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconAlerts",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconAlertsSolid.displayName = "IconAlertsSolid";
  return IconAlertsSolid;
}(Component);

IconAlertsSolid.glyphName = 'alerts';
IconAlertsSolid.variant = 'Solid';
IconAlertsSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconAlertsSolid;
export { IconAlertsSolid };